import React from "react";
import NavBar from "../other/NavBar";
import Footer from "../frontPage/homePageSections/Footer";
import Title from "../other/title/Title";
import "./PrivacyPolicy.css";
import { Container } from "@mui/system";
function TOS() {
  return (
    <div>
      <NavBar />
      <Container maxWidth="xl">
        <main style={{ marginTop: "10em" }}>
          <Title
            strong="Terms and Conditions
"
          />
          <p>
            These Terms and Conditions (“Terms”, “Terms and Conditions”) govern
            your relationship with the speedyourweb.com website (the “Service”)
            (“us”, “we”, “Speedyourweb.com”, or “our”). Please read these Terms
            and Conditions carefully before using the Service. Your access to
            and use of the Service is conditioned on your acceptance of and
            compliance with these Terms. These Terms apply to all visitors,
            users, and others who access or use the Service. By accessing or
            using the Service you agree to be bound by these Terms. If you
            disagree with any part of the terms then you may not access the
            Service.
          </p>
          <h3>Purchases</h3>
          <p>
            If you wish to purchase any product or service made available
            through the Service (“Purchase”), you may be asked to supply certain
            information relevant to your Purchase including, without limitation,
            your credit card number, the expiration date of your credit card,
            your billing address, and your shipping information. You represent
            and warrant that: (i) you have the legal right to use any credit
            card(s) or another payment method (s) in connection with any
            Purchase; and that (ii) the information you supply to us is true,
            correct and complete. By submitting such information, you grant us
            the right to provide the information to third parties for purposes
            of facilitating the completion of Purchases. We reserve the right to
            refuse or cancel your order at any time for specific reasons
            including but not limited to product or service availability, errors
            in the description or price of the product or service, error in your
            order, or other reasons. We reserve the right to refuse or cancel
            your order if fraud or an unauthorized or illegal transaction is
            suspected. We may add some issues on third party of payments that
            they have the responsibility of their credit card information
          </p>
          <h3>Refund Policy</h3>
          <p>
            We will do our very best to help you fix or resolve your website’s
            issues. In the event that we are unable to resolve the issues or
            have given up, a full refund will be sent to you. However, if you
            decide to cancel your support request before having the opportunity
            to work on it or if you are unable to provide the access we need,
            there will be only a refund of 50% of what was paid to us. The same
            applies if we investigate an issue for you, but find nothing wrong
            with the website. The reason for this is that we have operating
            costs that are incurred when a support ticket is submitted and in
            many cases, the agent has already completed a portion of the work.
            No refunds are provided after the first 30 days.
          </p>
          <h3>Availability, Errors, and Inaccuracies</h3>
          <p>
            We are constantly updating our offerings of products and services on
            the Service. The products or services available on our Service may
            be mispriced, described inaccurately, or unavailable, and we may
            experience delays in updating information on the Service and in our
            advertising on other websites. We cannot and do not guarantee the
            accuracy or completeness of any information, including prices,
            product images, specifications, availability, and services. We
            reserve the right to change or update information and to correct
            errors, inaccuracies, or omissions at any time without prior notice.
          </p>
          <h3>Contests, Sweepstakes, and Promotions</h3>
          <p>
            Any contests, sweepstakes or other promotions (collectively,
            “Promotions”) made available through the Service may be governed by
            rules that are separate from these Terms. If you participate in any
            Promotions, please review the applicable rules and our Privacy
            Policy. If the rules for a Promotion conflict with these Terms, the
            Promotion rules will apply.
          </p>
          <h3>Intellectual Property</h3>
          <p>
            The Service and its original content, features, and functionality
            are and will remain the exclusive property of Speedyourweb.com and
            its licensors. The Service is protected by copyright, trademark, and
            other laws. Our trademarks and trade dress may not be used in
            connection with any product or service without the prior written
            consent of Speedyourweb.com.
          </p>
          <h3>Links To Other Web Sites and Third Party Services</h3>
          <p>
            Our Service may link and utilize third-party websites or services
            that are not owned or controlled by Speedyourweb.com.
            Speedyourweb.com has no control over and assumes no responsibility
            for, the content, privacy policies, or practices of any third-party
            websites or services. You further acknowledge and agree that
            Speedyourweb.com shall not be responsible or liable, directly or
            indirectly, for any damage or loss caused or alleged to be caused by
            or in connection with the use of or reliance on any such content,
            goods, or services available on or through any such websites or
            services. We strongly advise you to read the terms and conditions
            and privacy policies of any third-party websites or services that
            you visit. Backups We are not responsible for Content residing on
            the Website. In no event shall we be held liable for any loss of any
            Content. It is your sole responsibility to maintain an appropriate
            backup of your Content. Notwithstanding the foregoing, on some
            occasions and in certain circumstances, with absolutely no
            obligation, we may be able to restore some or all of your data that
            has been deleted as of a certain date and time when we may have
            backed up data for our own purposes. We make no guarantee that the
            data you need will be available.
          </p>
          <p>
            We may terminate or suspend your access immediately, without prior
            notice or liability, for any reason whatsoever, including without
            limitation if you breach the Terms. Upon termination, your right to
            use the Service will immediately cease.
          </p>
          <h3>Limitation Of Liability</h3>
          <p>
            In no event shall Speedyourweb.com, nor its directors, employees,
            partners, agents, suppliers, or affiliates, be liable for any
            indirect, incidental, special, consequential, or punitive damages,
            including without limitation, loss of profits, data, use, goodwill,
            or other intangible losses, resulting from (i) your access to or use
            of or inability to access or use the Service; (ii) any conduct or
            content of any third party on the Service; (iii) any content
            obtained from the Service; and (iv) unauthorized access, use or
            alteration of your transmissions or content, whether based on
            warranty, contract, tort (including negligence) or any other legal
            theory, whether or not we have been informed of the possibility of
            such damage, and even if a remedy set forth herein is found to have
            failed of its essential purpose.
          </p>
          <h3>Disclaimer</h3>
          <p>
            Speedyourweb.com its subsidiaries, affiliates, and its licensors do
            not warrant that a) the Service will function uninterrupted, secure,
            or available at any particular time or location; b) any errors or
            defects will be corrected; c) the Service is free of viruses or
            other harmful components, or d) the results of using the Service
            will meet your requirements.
          </p>
          <p>
            Your use of the Service is at your sole risk. The Service is
            provided on an “AS IS” and “AS AVAILABLE” basis. The Service is
            provided without warranties of any kind, whether express or implied,
            including, but not limited to, implied warranties of
            merchantability, fitness for a particular purpose, non-infringement,
            or course of performance. Indemnification You agree to indemnify and
            hold Speedyourweb.com and its affiliates, directors, officers,
            employees, and agents harmless from and against any liabilities,
            losses, damages, or costs, including reasonable attorneys’ fees,
            incurred in connection with or arising from any third-party
            allegations, claims, actions, disputes, or demands asserted against
            any of them as a result of or relating to your Content, your use of
            the Website or Services or any willful misconduct on your part.{" "}
          </p>
          <h3>Governing Law</h3>
          <p>
            These Terms shall be governed and construed in accordance with the
            laws of Israel, without regard to its conflict of law provisions.
            Our failure to enforce any right or provision of these Terms will
            not be considered a waiver of those rights. If any provision of
            these Terms is held to be invalid or unenforceable by a court, the
            remaining provisions of these Terms will remain in effect. These
            Terms constitute the entire agreement between us regarding our
            Service, and supersede and replace any prior agreements we might
            have between us regarding the Service.
          </p>
          <h3>Severability</h3>
          <p>
            All rights and restrictions contained in this Agreement may be
            exercised and shall be applicable and binding only to the extent
            that they do not violate any applicable laws and are intended to be
            limited to the extent necessary so that they will not render this
            Agreement illegal, invalid or unenforceable. If any provision or
            portion of any provision of this Agreement shall be held to be
            illegal, invalid, or unenforceable by a court of competent
            jurisdiction, it is the intention of the parties that the remaining
            provisions or portions thereof shall constitute their agreement with
            respect to the subject matter hereof, and all such remaining
            provisions or portions thereof shall remain in full force and
            effect.
          </p>
          <h3>Changes</h3>
          <p>
            We reserve the right, at our sole discretion, to modify or replace
            these Terms at any time. If a revision is material we will try to
            provide at least 30 days' notice prior to any new terms taking
            effect. What constitutes a material change will be determined at our
            sole discretion. By continuing to access or use our Service after
            those revisions become effective, you agree to be bound by the
            revised terms. If you do not agree to the new terms, please stop
            using the Service.
          </p>
          <h3>Contact Us</h3>{" "}
          <p>If you have any questions about these Terms, please contact us.</p>{" "}
          <p>Last updated: July 11, 2022</p>
        </main>
      </Container>
      <Footer />
    </div>
  );
}

export default TOS;
